// extracted by mini-css-extract-plugin
module.exports = {"root":"HelpButton_root__3wAN4","icon":"HelpButton_icon__2Voj3"};